import { useRouteError, Link } from 'react-router';
import { SecondaryButton } from '../components/SecondaryButton';

export default function ErrorPage() {
  const error = useRouteError() as any;

  const errorMessage =
    error?.message ||
    error?.statusText ||
    'An unexpected error occurred';

  const isDev = import.meta.env.DEV;

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4">
      <div className="max-w-md text-center">
        <h1 className="font-['Playfair_Display',sans-serif] font-extrabold text-[#8e2a2f] text-[34px] leading-[48px] tracking-[-0.0944px] mb-4">
          Oops!
        </h1>
        <p className="font-['DM_Sans',sans-serif] text-[#908e8e] text-sm leading-[21px] tracking-[-0.1px] mb-6">
          Something went wrong. We're working to fix it. Please try again later or go back home.
        </p>
        
        {isDev && errorMessage && (
          <div className="bg-red-50 border border-red-200 rounded-md p-4 mb-6 text-left">
            <p className="text-xs font-mono text-red-700 break-words">
              {errorMessage}
            </p>
          </div>
        )}

        <div className="flex gap-3 justify-center">
          <Link to="/">
            <SecondaryButton>Go Home</SecondaryButton>
          </Link>
        </div>
      </div>
    </div>
  );
}
